import type { RasterLayerSource } from '@/hooks/useDatasets';
import { releaseTilesPath } from './releaseTiles';
import type { LayerConfig } from './types';
import { DEFAULT_TREE_COVER_MIN_ZOOM, LayerType } from './types';
import { TileLayer } from '@deck.gl/geo-layers';
import { BitmapLayer } from '@deck.gl/layers';
import { getGeoBoundingBox } from '@/views/map/utils';

const SEGMENTATION_COLOR = [49, 226, 188, 180];

export const getSegmentationLayer = (
  source: RasterLayerSource,
  config: LayerConfig,
  minZoom = DEFAULT_TREE_COVER_MIN_ZOOM,
  maxZoom = 18
) => {
  const cmap = {
    '0': [0, 0, 0, 0],
    '1': SEGMENTATION_COLOR,
  };
  const cmap_param = encodeURIComponent(JSON.stringify(cmap));

  return new TileLayer({
    id: LayerType[LayerType.segmentation],
    data: `${releaseTilesPath(source, 'png')}?pixel_selection=first&return_mask=true&bidx=1&resampling=nearest&colormap=${cmap_param}&tilesize=512`,
    loadOptions: {
      fetch: {
        credentials: 'include',
      },
    },
    minZoom,
    maxZoom,
    visible: config.visible,
    renderSubLayers: (props) => {
      if (props.data === null) {
        return null;
      }

      const boundingBox = getGeoBoundingBox(props);
      if (!boundingBox) {
        return null;
      }
      const { west, south, east, north } = boundingBox;

      return new BitmapLayer({
        id: props.id,
        image: props.data,
        bounds: [west, south, east, north],
        highlightColor: props.highlightColor,
        opacity: props.opacity,
        visible: props.visible,
      });
    },
  });
};
